import RAW from "@/data/stores.json";

export const ALL_STORES = (Array.isArray(RAW) ? RAW : []).map((s, i) => ({ ...s, id: i }));
export const MAPPED_STORES = ALL_STORES.filter((s) => s.lat != null && s.lng != null);

export const km = (a, b) => {
  const r = (d) => (d * Math.PI) / 180;
  const h = Math.sin(r(b.lat - a.lat) / 2) ** 2 + Math.cos(r(a.lat)) * Math.cos(r(b.lat)) * Math.sin(r(b.lng - a.lng) / 2) ** 2;
  return 12742 * Math.asin(Math.sqrt(h));
};

export const fmtKm = (d) => `${d < 10 ? d.toFixed(1) : Math.round(d)} km`;

export const directionsUrl = (s) => `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(`${s.name}, ${s.address}`)}`;


const LETTER_PROV = { A: "NL", B: "NS", C: "PE", E: "NB", G: "QC", H: "QC", J: "QC", K: "ON", L: "ON", M: "ON", N: "ON", P: "ON" };
const avg = (list) => (list.length ? { lat: list.reduce((s, x) => s + x.lat, 0) / list.length, lng: list.reduce((s, x) => s + x.lng, 0) / list.length } : null);

// Offline fallback: centre of our stores sharing the postal code's first 3 characters, then its province.
export const approxFromPostal = (postal) => {
  const code = postal.toUpperCase().replace(/\s/g, "");
  const fsa = code.slice(0, 3);
  const sameFsa = MAPPED_STORES.filter((s) => (s.address || "").toUpperCase().replace(/\s/g, "").includes(fsa) && /[A-Z]\d[A-Z]\d[A-Z]\d/.test((s.address || "").toUpperCase().replace(/\s/g, "")));
  return avg(sameFsa) || avg(MAPPED_STORES.filter((s) => s.prov === LETTER_PROV[code[0]]));
};
